import React from 'react';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Switch, Route} from 'react-router-dom';
import Navbar from './Navbar';
import HomePage from './HomePage';
import Topdishes from './Topdishes';
import Fooddishes from './Fooddishes';
import Vegetable from './Vegetable';
import Footer from './Footer';
import ChoostseezCard from './ChoostseezCard';
function App() {
  return(
    <>
    <Navbar />
    <Switch>
      <Route exact path="/" component={HomePage} />
      <Route exact path="/topdishes" component={Topdishes} />
      <Route exact path="/fooddishes" component={Fooddishes} />
      <Route exact path="/vegetables" component={Vegetable} />
      <Route exact path="/carddetail" component={ChoostseezCard} />
    </Switch>
    <Footer />
    </>
  )
}
export default App;
